import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DesktopHomeLogoProps {
  className?: string;
}

const DesktopHomeLogo: React.FC<DesktopHomeLogoProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/projects', { replace: true })}
      className={`hidden lg:flex items-center ${className}`.trim()}
      aria-label="Zur Startseite"
      title="360Volt Startseite"
    >
      <img
        src="/360volt-logo.png"
        alt="360Volt"
        className="h-8 w-auto"
      />
    </button>
  );
};

export default DesktopHomeLogo;
